import { Button } from "@wordpress/components";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import settings from "settings";

const CheckoutButton = () => {
	const navigate = useNavigate();
	const user = useSelector(({ auth }) => auth.user);

	const handleClick = () => {
		if (user.isUserLoaded) {
			window.location.href = settings.urls.checkout;
		} else {
			navigate("/account/login");
		}
	};
	return <Button onClick={handleClick}>Checkout</Button>;
};

export default CheckoutButton;
